import { SxStyle } from '@aibees/shared/theme';

export const button = (active: boolean | undefined, disabled: boolean) => ({
  height: (p: any) => p.spacing(4.75),
  minWidth: '100%',
  borderRadius: 0,
  color: active
    ? (p: any) => p.palette.primary[500]
    : (p: any) => p.palette.grey[600],
  '&.Mui-disabled': {
    border: 'none',
  },
  opacity: disabled ? 0.5 : 1,
});

export const icon: SxStyle = {};

export const content: SxStyle = {
  background: (p) => p.palette.common.white,
  flex: 1,
  border: '1px solid',
  borderColor: (p) => p.palette.grey[300],
  borderLeft: 0,
};

export const tabWrapper: SxStyle = {
  border: '1px solid',
  borderColor: (p) => p.palette.grey[300],
};
